import { api } from "./api";
import { cartEndpoints } from "../constants/endpoints";

type FetchCartByCustomerId = {
  customerId: string;
};

type cartData = {
  productId: string;
  unit: number;
  quantity: number;
};

type deletedProductsFromCart = {
  productId: string;
};

type updateCartByCustomerIdprops = {
  customerId: string;
  cartData: cartData[];
  deletedProductsFromCart: deletedProductsFromCart[];
};

export const FetchCartByCustomerId = async (props: FetchCartByCustomerId) => {
  const endPointUrl = `${cartEndpoints.getCartByCustomerId}/${props.customerId}`;
  try {
    return await api.get(endPointUrl);
  } catch (error) {
    throw new Error("Failed to fetch customers");
  }
};

export const updateCartByCustomerId = async (
  props: updateCartByCustomerIdprops
) => {
  const endPointUrl = `${cartEndpoints.getCartByCustomerId}/${props.customerId}`;
  const payload = { ...props };
  return await api.put(endPointUrl, payload);
};
